var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchSvgomg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.814 24.726-6.401-6.402a.626.626 0 0 0-.449-.184h-.696a10.938 10.938 0 0 0 2.668-7.172C21.936 4.91 17.027 0 10.968 0S0 4.91 0 10.968c0 6.06 4.91 10.968 10.968 10.968 2.742 0 5.247-1.007 7.172-2.668v.696c0 .169.068.327.184.449l6.402 6.401a.633.633 0 0 0 .896 0l1.192-1.192a.633.633 0 0 0 0-.896Zm-15.846-5.32a8.435 8.435 0 0 1-8.437-8.438 8.435 8.435 0 0 1 8.437-8.437 8.435 8.435 0 0 1 8.437 8.437 8.435 8.435 0 0 1-8.437 8.437Z",
    fill: "#EC0344"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSvgomg);
export default __webpack_public_path__ + "static/media/search-svgomg.0c63025487ebf4e25c3b31dc8a972ce2.svg";
export { ForwardRef as ReactComponent };